import { render, staticRenderFns } from "./pieItem copy.vue?vue&type=template&id=1bc2492e&scoped=true"
import script from "./pieItem copy.vue?vue&type=script&lang=js"
export * from "./pieItem copy.vue?vue&type=script&lang=js"
import style0 from "./pieItem copy.vue?vue&type=style&index=0&id=1bc2492e&prod&lang=scss&scoped=true"
import style1 from "./pieItem copy.vue?vue&type=style&index=1&id=1bc2492e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc2492e",
  null
  
)

export default component.exports